module.exports = __webpack_public_path__ + "img/uv.298672a4.png";